import { useQuery } from '@tanstack/react-query';
import fetchApi from './fetchApi';

const useRoomsQuery = () => useQuery({ queryKey: ['rooms'], queryFn: () => fetchApi<Odoo.Room[]>('/api/rooms') });

export default useRoomsQuery;
